import CloseModal from "@assets/images/CloseModal.svg";
import LibraryIcon from "@assets/images/library.svg";
import SearchIconDark from "@assets/images/search-dark.svg";
import Search from "@assets/images/Search-new.svg";
import SoldToIcon from "@assets/images/sold-to-party.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from "@material-ui/core";
import FormField from "@saleor/components/FormField/FormField";
import MyTypography from "@saleor/components/MyTypography";
import DialogError from "@saleor/createOrChangeNotRefContract/components/Dialog/DialogeError";
import ModalTransportZone from "@saleor/createOrChangeNotRefContract/components/ModalAddress/ModalTransportZone";
import { isDirtyField } from "@saleor/createOrChangeNotRefContract/utils";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import InlineSVG from "react-inlinesvg/esm";
import { FormattedMessage } from "react-intl/lib";

import useOneTimeCustomer from "./useOneTimeCustomer";
import useOneTimeFormiks from "./useOnetimeFormiks";
export interface ModalAddressProps {
  onClose: () => void;
  visible: boolean;
  address: Array<{ name: string; code: string }>;
  handleApplyAddress: (shipping: string, shippingAddr: string) => void;
  defaultAddress: string;
  formik?: FormikProps<any>;
  formikOtcSoldTo?: FormikProps<any>;
  handleShowDetails?: any;
  onOpen: () => void;
  createPreDraft?: () => void;
  formType?: string;
}

const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "20px 24px 10px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    btnSearch: {
      width: "100%",
      height: "20px",
      right: "auto",
      top: "8px",
      marginLeft: "0px",
      padding: " 6px",
      minWidth: "32px",
      position: "absolute",
      background: "transparent",
      justifyContent: "right",
      "&:hover": {
        background: "transparent"
      }
    },
    rowFlex: {
      display: "flex",
      padding: "5px 8px 5px 16px",
      justifyContent: "space-between",
      alignItems: "flex-start",
      alignSelf: "stretch",
      borderRadius: "4px",
      border: "1px solid var(--Grayscale-Silver, #CCC)",
      background: "var(--Grayscale-White, #FFF)",
      width: "100%"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 580,
        width: "100%",
        borderRadius: 12
      },
      "& .MuiDialogTitle-root": {
        paddingTop: 24
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    addressButton: {
      marginLeft: "7px",
      width: "280px",
      height: "30px",
      fontSize: "14px",
      marginRight: "159px"
    },
    searchIcon: {
      height: "20px",
      width: "20px"
    },
    dialogContent: {
      width: "100%",
      background: "#F2FAFB",
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    nameHead: {
      marginTop: 5,
      marginLeft: "7px",
      color: "#009FB8"
    },
    nameHeadSoldTo: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    }
  }),
  { name: "ModalAddress" }
);

const ModalAddress: React.FC<ModalAddressProps> = props => {
  const [submitted, setSubmitted] = useState<boolean>(false);

  const {
    visible,
    onClose,
    formik,
    handleShowDetails,
    onOpen,
    formType
  } = props;

  const { formikOneTimeSoldTo } = useOneTimeFormiks(
    { ...props?.formik?.values?.otcSoldTo },
    submitted
  );
  const { formOneTimeData } = useOneTimeCustomer(
    formikOneTimeSoldTo,
    formik,
    visible
  );
  const classes = useStyles();
  const [visibles, setVisibles] = useState<boolean>(false);
  const [visibless, setVisibless] = useState(false);
  const isOtherCountry = formikOneTimeSoldTo?.values?.countryCode !== "TH";
  const formTypeSoldTo = formType === "soldTo";

  useEffect(() => {
    if (isDirtyField(formikOneTimeSoldTo, "countryCode")) {
      formikOneTimeSoldTo.setValues(prev => ({
        ...prev,
        city: "",
        district: "",
        subDistrict: "",
        postalCode: "",
        street1: "",
        street2: "",
        transportZoneCode: "",
        transportZoneName: ""
      }));
    }
  }, [formikOneTimeSoldTo.values.countryName]);

  useEffect(() => {
    if (isDirtyField(formikOneTimeSoldTo, "city")) {
      formikOneTimeSoldTo.setValues(prev => ({
        ...prev,
        district: "",
        subDistrict: "",
        postalCode: ""
      }));
    }
  }, [formikOneTimeSoldTo.values.city]);

  useEffect(() => {
    if (isDirtyField(formikOneTimeSoldTo, "district")) {
      formikOneTimeSoldTo.setValues(prev => ({
        ...prev,
        subDistrict: "",
        postalCode: ""
      }));
    }
  }, [formikOneTimeSoldTo.values.district]);
  const handleOnCloseError = () => {
    setVisibles(false);
    onOpen();
  };
  const paymentTerm = formikOneTimeSoldTo?.values?.paymentTerm;
  const orderType =
    paymentTerm === "NT00" || paymentTerm === "AP00" ? "ZP20" : "";
  const handleTaxSubmit = () => {
    onClose();
    setVisibles(false);
    formik.setValues(prev => ({
      ...prev,
      isOneTimeCustomer: true,
      soldToCode: formikOneTimeSoldTo?.values?.soldToCode,
      soldToDisplayText: formikOneTimeSoldTo?.values?.soldToDisplayText,
      otcSoldTo: formikOneTimeSoldTo?.values,
      otcShipTo: formikOneTimeSoldTo?.values,
      otcBillTo: formikOneTimeSoldTo?.values,
      salesEmployee: formikOneTimeSoldTo?.values?.salesEmployee,
      paymentTerm: formikOneTimeSoldTo?.values?.paymentTerm,
      cash: orderType === "ZP20" ? "ชำระเงินแล้ว" : "",
      taxClass: formikOneTimeSoldTo?.values?.taxClass,
      customerName: formikOneTimeSoldTo?.values?.name1,
      callPreDraft: true
    }));

    onClose();
    handleShowDetails(true);
  };
  const handleButtonClick = () => {
    setVisibless(true);
  };
  const handleClickVatInfo = () => {
    window.open(
      "https://vsinter.rd.go.th/rd-webcontent-web/#/vatsearch",
      "_blank",
      "noopener"
    );
  };

  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const taxId = formikOneTimeSoldTo?.values?.taxId.length;
  const branchId = formikOneTimeSoldTo?.values?.branchId.length;
  const handleSubmit = async () => {
    const validation = await formikOneTimeSoldTo.validateForm();
    setSubmitted(true);
    if (isOtherCountry) {
      delete validation?.branchId;
      delete validation?.taxId;
    }
    if (validation && Object.keys(validation).length <= 0) {
      setVisibles(true);
      if ((taxId > 0 && branchId > 0) || isOtherCountry) {
        setVisibles(false);
        formik.setValues(prev => ({
          ...prev,
          isOneTimeCustomer: true,
          soldToCode: formikOneTimeSoldTo?.values?.soldToCode,
          soldToDisplayText: formikOneTimeSoldTo?.values?.soldToDisplayText,
          otcSoldTo: formikOneTimeSoldTo?.values,
          otcShipTo: formikOneTimeSoldTo?.values,
          otcBillTo: formikOneTimeSoldTo?.values,
          salesEmployee: formikOneTimeSoldTo?.values?.salesEmployee,
          paymentTerm: formikOneTimeSoldTo?.values?.paymentTerm,
          taxClass: formikOneTimeSoldTo?.values?.taxClass,
          customerName: formikOneTimeSoldTo?.values?.name1,
          cash: orderType === "ZP20" ? "ชำระเงินแล้ว" : "",
          callPreDraft: true
        }));

        onClose();
        handleShowDetails(true);
      }
    }
  };
  const handleSoldToSubmit = async () => {
    const validation = await formikOneTimeSoldTo.validateForm();
    setSubmitted(true);
    delete validation?.salesEmployee;
    delete validation?.taxClass;
    if (isOtherCountry) {
      delete validation?.branchId;
      delete validation?.taxId;
    }
    if (validation && Object.keys(validation).length <= 0) {
      formik.setValues(prev => ({
        ...prev,
        otcSoldTo: formikOneTimeSoldTo?.values
      }));
      onClose();
    }
  };
  const formIconHead = useMemo(() => {
    switch (formType) {
      case "soldTo":
        return {
          iconHead: SoldToIcon,
          nameHead: "Sold-to Party"
        };
      default:
        return {
          iconHead: LibraryIcon,
          nameHead: "One-time Customer"
        };
    }
  }, [formType]);
  return (
    <>
      <Dialog
        open={visible}
        className={classes.root}
        data-testid="modalAddressOneTime"
      >
        <DialogTitle className={classes.dialogTitle}>
          <div className={classes.dialogTitleWrap}>
            <img src={formIconHead?.iconHead} alt="" />
            <MyTypography
              variant={"h6"}
              className={
                formTypeSoldTo ? classes.nameHeadSoldTo : classes.nameHead
              }
              style={{ whiteSpace: "nowrap" }}
              data-testid="modal-address-title"
            >
              {formIconHead?.nameHead}
            </MyTypography>
            <InlineSVG
              onClick={onClose}
              src={CloseModal}
              height={24}
              width={24}
              style={{
                cursor: "pointer",
                marginLeft: formType === "soldTo" ? "320px" : "290px"
              }}
            />
          </div>
        </DialogTitle>
        <DialogContent dividers={false} className={classes.dialogContent}>
          <Grid container spacing={2} justify="space-between">
            {formOneTimeData.map((field, index) => {
              if (!field?.hideField) {
                switch (field.type) {
                  case "Headers":
                    return (
                      <Grid item key={index} md={12}>
                        <MyTypography variant="h7" className={classes.nameHead}>
                          {field.title}
                        </MyTypography>
                      </Grid>
                    );

                  case "transportationZone":
                    return (
                      <Grid item key={index} md={6}>
                        <p
                          style={{
                            fontWeight: 600,
                            marginBottom: "-2px",
                            marginTop: "9px"
                          }}
                        >
                          {field.title}
                        </p>
                        <Button
                          id="searchTransportationZone"
                          data-testid="searchTransportationZone"
                          onClick={handleButtonClick}
                          className={classes.rowFlex}
                          style={{
                            marginBottom: 0,
                            height: "36px",
                            border: "1px solid #CCCCCC",
                            fontSize: "14px",
                            fontWeight: "normal",
                            alignItems: "center",
                            cursor: "pointer"
                          }}
                        >
                          {formikOneTimeSoldTo.values?.transportZoneCode !==
                          "" ? (
                            <span
                              style={{ color: "#222222", paddingRight: "0px" }}
                            >
                              {formikOneTimeSoldTo?.values?.transportZoneCode} -
                              {formikOneTimeSoldTo?.values?.transportZoneName}
                            </span>
                          ) : (
                            <span
                              style={{ color: "#999999", paddingRight: "0px" }}
                            >
                              เลือก Transportation Zone
                            </span>
                          )}
                          <Button
                            ref={anchorRef}
                            id="searchTransportationZoneIcon"
                            onClick={() => null}
                            style={{
                              marginRight: "-20px",
                              marginLeft: "-20px",
                              alignSelf: "center"
                            }}
                          >
                            <InlineSVG
                              src={SearchIconDark}
                              width={24}
                              height={24}
                            />
                          </Button>
                        </Button>
                      </Grid>
                    );

                  case "Button":
                    return (
                      <Button
                        id="vatInfo"
                        key={index}
                        variant="contained"
                        color={"secondary"}
                        className={classes.addressButton}
                        startIcon={
                          <InlineSVG
                            src={Search}
                            className={classes.searchIcon}
                          />
                        }
                        onClick={handleClickVatInfo}
                      >
                        {field.title}
                      </Button>
                    );

                  default:
                    return (
                      !field?.hideField && (
                        <React.Fragment key={index}>
                          <FormField
                            gridStyle={{ alignSelf: "flex-end" }}
                            {...field}
                            value={formikOneTimeSoldTo.values[field.name]}
                            handleChange={formikOneTimeSoldTo.handleChange}
                            name={field.name}
                            error={formikOneTimeSoldTo.errors[field.name]}
                            id={field.name}
                          />
                        </React.Fragment>
                      )
                    );
                }
              }
            })}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            id="closeButton"
            data-testid="closeButton"
            variant={"outlined"}
            color={"secondary"}
            className={classes.buttonAction}
            onClick={onClose}
          >
            <FormattedMessage defaultMessage={"ยกเลิก"} />
          </Button>
          <Button
            id="submitButton"
            data-testid="submitButton"
            variant={"contained"}
            color={"secondary"}
            className={classes.buttonAction}
            // disabled={!Boolean(shipping)}
            onClick={formTypeSoldTo ? handleSoldToSubmit : handleSubmit}
          >
            <FormattedMessage defaultMessage={"ตกลง"} />
          </Button>
        </DialogActions>
      </Dialog>
      <DialogError
        visible={visibles}
        onClose={handleOnCloseError}
        taxId={taxId}
        branchId={branchId}
        onSubmit={handleTaxSubmit}
      />
      <ModalTransportZone
        visible={visibless}
        onClose={() => {
          setVisibless(false);
        }}
        formik={formikOneTimeSoldTo}
        anchorRef={anchorRef}
      />
    </>
  );
};

ModalAddress.displayName = "ModalAddress";
export default ModalAddress;
